<template>
    <section
        id="form"
        class="header-quote-container"
    >
        <div class="header-quote">
            <!-- eslint-disable vue/no-v-html -->
            <div class="header-quote__title-container">
                <div
                    v-if="pageHeader.title && !pageHeader.title_hide"
                    class="header-quote__title"
                    v-html="pageHeader.title"
                ></div>
                <div
                    v-if="pageHeader.subtitle"
                    class="header-quote__subtitle"
                    v-html="pageHeader.subtitle"
                ></div>
            </div>
            <div class="header-quote__inner">
                <div class="header-quote__quote-container">
                    <WatsonThemeCroForm />
                    <WatsonThemeForm :form="pageHeader.quote_form" />
                </div>

                <div class="header-quote__sidebar-container">
                    <div
                        class="header-quote__selling-points-container"
                    >
                        <div
                            v-for="(sellingPoint, index) in pageHeader.selling_points"
                            :key="index"
                            class="header-quote__selling-point"
                        >
                            <div class="header-quote__icon-container">
                                <img
                                    class="header-quote__usps-icon"
                                    :src="sellingPoint.icon.url"
                                    :alt="sellingPoint.headline"
                                    loading="lazy"
                                    :width="sellingPoint.image?.width > 1 ? sellingPoint.image.width : null"
                                    :height="sellingPoint.image?.height > 1 ? sellingPoint.image.height : null"
                                >
                            </div>
                            <div class="header-quote__usps-text">
                                <span class="header-quote__usps-popper">
                                    <Popper
                                        placement="top"
                                        arrow
                                    >
                                        <button class="header-quote__popper-button">{{ sellingPoint.headline }}</button>
                                        <template #content>
                                            <div class="header-quote__popper-content">{{ sellingPoint.description }}</div>
                                        </template>
                                    </Popper>
                                </span>
                                <span class="header-quote__usps-headline">
                                    {{ sellingPoint.headline }}
                                </span>

                                <p v-if="sellingPoint.description" class="header-quote__usps-subtitle">
                                    {{ sellingPoint.description }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <Media
                        v-if="pageHeader.media_type !== 'none'"
                        :type="pageHeader.media_type"
                        :inline="true"
                    />

                    <watson-theme-header-trustpilot-widget
                        v-if="pageHeader.enable_trustpilot_quote"
                        :business-id="pageHeader.trustpilot_widget_businessunit"
                        :template-id="pageHeader.trustpilot_widget_templateid"
                        :url="pageHeader.trustpilot_widget_site_url"
                        :hide="pageHeader.hide_trustpilot_quote"
                    />
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import Popper from 'vue3-popper';
import Media from '../../header-components/media/watson-theme-header-media.vue';
import WatsonThemeForm from '../../../../../components/form/watson-theme-form.vue';
import WatsonThemeCroForm from '../../header-components/cro-form/watson-theme-cro-form.vue';
import WatsonThemeHeaderTrustpilotWidget
    from '../../header-components/trustpilot-widget/watson-theme-header-trustpilot-widget.vue';

defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-header-quote";
</style>
